import React from "react";
import CommentList from "./subcomponents/CommentList";
import CommentForm from "./subcomponents/CommentForm";

const CommentSection = props => (
  <div>
    <CommentForm
      comment={props.comment}
      onCommentChange={props.onCommentChange}
      handleOnClick={props.handleOnClick}
      isValid={props.isValid}
      selectedMessageLogType={props.selectedMessageLogType}
      messageLogTypes={props.messageLogTypes}
      onMessageLogTypeChange={props.onMessageLogTypeChange}
    />
    <CommentList comments={props.comments} />
  </div>
);

export default CommentSection;
